import { render } from "./PaymentSelectedChanelPanel.vue?vue&type=template&id=ccb53b64&scoped=true&ts=true"
import script from "./PaymentSelectedChanelPanel.vue?vue&type=script&lang=ts"
export * from "./PaymentSelectedChanelPanel.vue?vue&type=script&lang=ts"

import "./PaymentSelectedChanelPanel.vue?vue&type=style&index=0&id=ccb53b64&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb53b64"]])

export default __exports__